module.exports = __webpack_public_path__ + "img/clsj.ce192d96.png";